import { render, staticRenderFns } from "./EducationSection.vue?vue&type=template&id=61b6556b&"
import script from "./EducationSection.vue?vue&type=script&lang=js&"
export * from "./EducationSection.vue?vue&type=script&lang=js&"
import style0 from "./EducationSection.vue?vue&type=style&index=0&id=61b6556b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports